module.exports = __webpack_public_path__ + "static/media/dBanner4.f26410e7.png";